import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[900px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            {aboutContent.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-6">{aboutContent.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-[700px] mx-auto mb-8">
            {aboutContent.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {aboutContent.highlights.map((h, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-primary-500 rounded-lg mx-auto mb-3">
                  <i className={`${h.icon} text-white text-lg`}></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-950 mb-1">{h.label}</h3>
                <p className="text-xs text-foreground-500">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}